export const issueOptions = {
    delays: "delays",
    disappointedClient: "disappointedClient",
    damagedProduct: "damagedProduct",
    missingItemsInOrder: "missingItemsInOrder",
    corruptedFood: "corruptedFood",
    other: "other",
    earlySupply: "earlySupply"
};

export const issueOptionsToText = {
    [issueOptions.disappointedClient]: "אכזה סובייקטיבית",
    [issueOptions.damagedProduct]: "אוכל פגום (שבור/ מעוך וכו'..)",
    [issueOptions.corruptedFood]: "אוכל לא טרי/ מקולקל",
    [issueOptions.missingItemsInOrder]: "חוסרים בהזמנה",
    [issueOptions.delays]: "איחורים",
    [issueOptions.earlySupply]: "הקדמה",
    [issueOptions.other]: "אחר"
};

export const compensationOptions = {
    couponCode: "couponCode",
    partialDiscount: "partialDiscount",
    additionalProductsCurrentOrder: "additionalProductsCurrentOrder",
    additionalProductsNextOrder: "additionalProductsNextOrder",
    noCompensation: "noCompensation"
};

export const compensationOptionsToText = {
    [compensationOptions.couponCode]: "קוד קופון ( שימוש עתידי)",
    [compensationOptions.partialDiscount]: "זיכוי יחסי מההזמנה ( תיעוד בהנחת קוד קופון)",
    [compensationOptions.additionalProductsCurrentOrder]: "מוצרים נוספים להזמנה הנוכחית ( טופל במעמד האירוע)",
    [compensationOptions.additionalProductsNextOrder]: "מוצרים נוספים להזמנה הבאה",
    [compensationOptions.noCompensation]: "אין פיצוי"
};

export const statusOptions = {
    providerHandling: "providerHandling",
    deliveryProviderHandling: "deliveryProviderHandling",
    csmHandling: "csmHandling",
    closedWithCustomer: "closedWithCustomer"
};

export const statusOptionsToText = {
    [statusOptions.providerHandling]: "בבירור מול הספק",
    [statusOptions.deliveryProviderHandling]: "בבירור מול השליח",
    [statusOptions.csmHandling]: "בטיפול CSM",
    [statusOptions.closedWithCustomer]: "נסגר מעגל עם הלקוח"
};
